module.exports = __webpack_public_path__ + "img/BINDI 5 LIME.c4f03e1.svg";